import paths from "../../api/paths.api";
import {
  ALL_PLANT_MODULE_NAMES,
  APP_MODULES,
  hasAnyModuleAccess,
  hasModuleAccess,
  isAdminUser,
  isLicenceAdminOverrideUser,
} from "../../constants/appModules";

// `visualKey` picks the item's icon and accent colour in the sidebar rail
// (see constants/moduleVisuals.js).
export const userNavItems = [
  // Estimation and EPCM used to be separate destinations (paths.myEstimation
  // and paths.myProjects); both are superseded by the sidebar tree
  // (AppSidebar), which already surfaces a project's Estimation entry points
  // per-plant (see the nine-dot launcher's Estimation group). "Project" just
  // opens the tree with an empty page until something's picked there - see
  // ProjectLanding. Gated the same way "EPCM" was, since that's what the
  // tree itself requires to show anything (see AppSidebar's
  // `showProjectsTree`).
  {
    label: "Project",
    type: "link",
    link: paths.myProjects,
    modulesAny: ALL_PLANT_MODULE_NAMES,
    visualKey: "projects",
  },
  {
    label: "AIMS",
    type: "link",
    link: paths.ams,
    module: APP_MODULES.AIMS,
    visualKey: "aims",
  },
  // {
  //   label: "Project Data",
  //   type: "link",
  //   link: paths.emsExplorer,
  //   module: APP_MODULES.EMS,
  // },
  {
    label: "Software",
    type: "link",
    link: paths.softwares,
    module: APP_MODULES.SOFTWARE,
    visualKey: "software",
  },
  {
    label: "Client data",
    type: "link",
    link: paths.clientVendors,
    visualKey: "client-data",
  },
  {
    label: "Licences",
    type: "link",
    link: paths.licenceManagement,
    adminOnly: true,
    module: APP_MODULES.LICENCE_ADMIN,
    visualKey: "licences",
  },
];

/**
 * Whether the user may open a nav item - the same rule ModuleRouteGuard
 * applies to the page behind it: admins open everything, admin-only items
 * are for admins (and the Licence Admin override users), the rest follow the
 * user's licensed modules.
 */
export const canAccessNavItem = (item, { user, allowedModules }) => {
  if (isAdminUser(user)) return true;
  if (item.adminOnly) return isLicenceAdminOverrideUser(user);
  if (item.modulesAny?.length) {
    return hasAnyModuleAccess(allowedModules, item.modulesAny);
  }
  if (item.module) {
    return hasModuleAccess(allowedModules, item.module);
  }
  return true;
};
